import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    customDashboardData: []
}
// Recently this component is not in used WILL USE LATER
const dashboardSlice = createSlice({
    name: 'customDashboard',
    initialState,
    reducers: {
        handleCustomDashboard(state, action) {
            // console.log('state and action', state, 'action', action)
            const customDashboardData = action.payload;

            return {
                // ...state,
                isAuthenticated: true,
                customDashboardData
            };
        }
    }
})
// console.log('dashboard slice action', dashboardSlice, 'dashboardSlice?.actions', dashboardSlice?.actions)
export const { handleCustomDashboard } = dashboardSlice?.actions
export default dashboardSlice?.reducer;